import { useMutation } from "react-query";
import { QueryCallbacks } from "../shared/interfaces/ReactQuery";
import { useContext } from "react";
import { ApiContext } from "../contexts/ApiContext";

export interface DownloadPdfRequest {
  generatedReportId?: number;
  customerId?: number;
  companyId?: number;
  siteId?: number;
  token?: string;
}

export function useDownloadPdf(callbacks?: QueryCallbacks<string>) {
  const apiContext = useContext(ApiContext);

  return useMutation(
    async (request: DownloadPdfRequest) => {
      return await apiContext.utp2FilesAPIs.getPdf(request);
    },
    {
      ...callbacks,
      onSuccess: (url) => {
        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.click();
        if (callbacks?.onSuccess) {
          callbacks.onSuccess(url);
        }
      },
    },
  );
}
